import { useQuery } from '@tanstack/react-query';
import fetchData from '@/utils/fetchData';
import useError from '@/hooks/useError';
import useSmartlook from '@/hooks/useSmartlook';

export function useClientConstraintsQuery(enabled = false) {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useQuery<ClientConstraints>({
    queryKey: ['client', 'application', 'constraints'],
    queryFn: async () => {
      try {
        const resp = await fetchData('/client/application/constraints');

        return resp;
      } catch (e) {
        error('[useApplicationQuery][GET /client/application/constraints]', e);
        showError();
        throw e;
      }
    },
    enabled,
  });
}

type TermLimit = {
  amountFrom: number;
  amountTo: number;
  termFrom: number;
  termTo: number;
  limitType: 'SPL' | 'IL';
};

export type ClientConstraints = {
  amountInterval: {
    min: number;
    max: number;
    step: number;
    defaultValue: number;
  };
  termInterval: {
    min: number;
    max: number;
    step: number;
    defaultValue: number;
  };
  termLimits: Array<TermLimit>;
};
